<template>
  <div class="imageEditorHeader">
    <ion-header>
      <ion-toolbar
        color="red"
        class="text-white flex items-end ml-background ion-no-border"
        :class="{ safeAreaTop: isMobile }"
      >
        <div class="container flex items-end">
          <img
            src="../../../../public/assets/mlLogos/logo-white-font.png"
            alt="ml_icon"
            class="logo mr-4"
          >
        </div>
      </ion-toolbar>
    </ion-header>
    <div class="viewerHolder">
      <div
        id="imageEditor"
        :class="{ safeArea: isMobile }"
        ref="editorContainer"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import { PropType, onMounted, ref } from 'vue';
import { IonHeader, IonToolbar, modalController } from '@ionic/vue';
//Models
import { instanceOfStrapiImage } from '@/models/photo/strapi-media.model';

import { getPhotoUrl } from '@/utilities/get-media-url';
import { AnnotationEditor } from '@markerjs/markerjs-ui';
import { APhoto } from '@/models/photo/a-photo.model';

const props = defineProps({
    image: {
      type: Object as PropType<APhoto>,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    }
  })

// References to DOM and MarkerArea
const editorContainer = ref<HTMLDivElement | null>(null);
const editor = ref<AnnotationEditor | null>(null);

onMounted(async () => {
    await loadEditor();
});

async function loadEditor() {

    if (editorContainer.value) {
        const imgUrl = getPhotoUrl(props.image);
        if(imgUrl === undefined) {
            console.error("Image URL is undefined");
            return;
        }
        const targetImg = document.createElement('img');
        targetImg.src = imgUrl;
        targetImg.crossOrigin="anonymous";

        editor.value = new AnnotationEditor();
        editor.value.targetImage = targetImg;

        editorContainer.value.appendChild(editor.value);

        editor.value.addEventListener("editorsave", (event) => {            
            const dataUrl = event.detail.dataUrl; // dataUrl contains data: "data:image/png;base64,iVBORw0K..."

            modalController.dismiss({newImg: dataUrl, oldId: instanceOfStrapiImage(props.image) ? props.image.id : props.image.uid}, 'save');
        });

        editor.value.addEventListener("editorclose", (event) => {
            modalController.dismiss(null, 'cancel');
        });

    }    
}

</script>

<style lang="scss">
.imageEditorHeader {
  height: 100%;
  display: flex;
  flex-direction: column;

  .viewerHolder {
    flex-grow: 1;
    height: calc(100% - 56px); /* Adjust height to account for header */

    #imageEditor {
      width: 100%;
      height: 100%;
    }
  }

  .safeArea {
      padding-bottom: env(safe-area-inset-bottom, 0px);
  }
  .safeAreaTop {
      padding-top: env(safe-area-inset-top, 0px);
  }

  .logo {
    height: 36px;
    filter: brightness(0) invert(1);
  } 
}
</style>
